module.exports = __webpack_public_path__ + "media/components/home/sign-up-free/img/sign-up-free-24af4cd04df23350659876941ef4c71c.jpg";